export default __webpack_public_path__ + "images/HQ.c937d0c.png";